/* ==========================================================================
   BeanBurds Smart Search  —  for the Tinker theme
   --------------------------------------------------------------------------
   Fixes the storefront's zero-result problem WITHOUT replacing the theme's
   search UI. It hooks the predictive-search request, repairs the query, and
   lets the theme render its own cards exactly as it already does.

   Three layers, each a strict improvement on the one below:
     1. Query repair   — "kgb select" -> "kbg select" before Shopify sees it.
     2. Local recovery — if Shopify still finds nothing, render OUR matches
                         through the theme's own resource-card markup via the
                         id: search the theme already uses for recently-viewed.
     3. Navigation     — brand / collection / guide pills from the local index.

   Fails safe: if the index can't load, every request passes through untouched
   and the storefront behaves exactly as it does today.

   Install: two assets + two lines in layout/theme.liquid. No other theme edits.
   ========================================================================== */
(function () {
  'use strict';

  if (window.__bbSmartSearch) return;
  window.__bbSmartSearch = true;

  var CFG = {
    indexUrl: window.BB_SEARCH_INDEX_URL || null,
    minChars: 2,
    maxPills: 3,
    debug: /[?&]bb_debug=1/.test(location.search)
  };
  function log() { if (CFG.debug) console.log.apply(console, ['[bb-search]'].concat([].slice.call(arguments))); }

  function routes() {
    var r = (window.Theme && window.Theme.routes) || {};
    return {
      predictive: r.predictive_search_url || '/search/suggest',
      search: r.search_url || '/search'
    };
  }

  /* ======================================================================
     1. Engine
     ====================================================================== */
  var AR_ALEF = /[آأإٱ]/g, AR_DIAC = /[ً-ْـٰ]/g;

  function norm(s) {
    if (!s) return '';
    return s.toString().toLowerCase()
      .normalize('NFD').replace(/[̀-ͯ]/g, '')
      .replace(AR_ALEF, 'ا').replace(/ة/g, 'ه').replace(/ى/g, 'ي')
      .replace(AR_DIAC, '')
      .replace(/[^a-z0-9؀-ۿ]+/g, ' ')
      .replace(/\s+/g, ' ').trim();
  }

  var STOP = {};
  ('for the a an and or with to me my i is are be at by from that this in on of ' +
   'best good want need looking buy get some any من في على الى عن مع').split(' ')
    .forEach(function (w) { STOP[w] = 1; });

  var PHRASE = [
    [/\bmo(c|k|kk|cc)?ha? ?master\b/g, 'moccamaster'],
    [/\bmoka ?master\b/g, 'moccamaster'],
    [/\bmocca ?master\b/g, 'moccamaster'],
    [/\bcof+e+\b/g, 'coffee'],
    [/\bexpres+o\b/g, 'espresso'],
    [/\bespres+o\b/g, 'espresso'],
    [/\bhand grinder\b/g, 'manual grinder'],
    [/\bmilk frother\b/g, 'milk pitcher frothing'],
    [/\bla ?marzoco\b/g, 'la marzocco'],
    [/\bone ?zpresso\b/g, '1zpresso']
  ];
  function phrases(s) { PHRASE.forEach(function (p) { s = s.replace(p[0], p[1]); }); return s; }

  var SYN = {
    mokamaster: ['moccamaster'], mocamaster: ['moccamaster'], moccomaster: ['moccamaster'],
    moka: ['moccamaster', 'bialetti'], mocha: ['moccamaster'],
    breville: ['sage'], brevile: ['sage'], brevill: ['sage'],
    nespresso: ['capsule', 'capsules'], marzocco: ['marzocco'], linea: ['marzocco'],
    zpresso: ['1zpresso'], xbloom: ['xbloom', 'xpods'],
    v60: ['hario', 'dripper'], pourover: ['pour', 'over', 'dripper'], dripper: ['dripper', 'over'],
    plunger: ['french', 'press'], frenchpress: ['french', 'press'],
    grinder: ['grinder', 'grinders'], grinders: ['grinder'], grider: ['grinder'],
    gringer: ['grinder'], burr: ['grinder'],
    machine: ['machine', 'machines'], maker: ['machine', 'brewer'], brewer: ['brewer', 'machine'],
    expresso: ['espresso'], espreso: ['espresso'],
    kettle: ['kettle', 'kettles'], gooseneck: ['kettle'],
    scale: ['scale', 'scales'], scales: ['scale'], tamper: ['tamper', 'tampers'],
    jug: ['jug', 'pitcher'], pitcher: ['pitcher', 'jug'],
    frother: ['milk', 'frothing'], steamer: ['milk', 'frothing'],
    papers: ['paper', 'filter'], pod: ['capsule', 'capsules'], pods: ['capsule', 'capsules'],
    bean: ['beans'], beans: ['beans'], decaff: ['decaf'], decaffeinated: ['decaf'],
    present: ['gift'], basket: ['basket', 'portafilter'],
    descaler: ['cleaning'], cleaner: ['cleaning'],
    'قهوه': ['coffee', 'beans'], 'بن': ['beans', 'coffee'], 'مطحنه': ['grinder'],
    'مكينه': ['machine'], 'اسبريسو': ['espresso'], 'اكواب': ['cups'], 'فلتر': ['filter']
  };

  var INTENT = [
    [/(machine|maker|brewer).*(home|house|kitchen)|home.*(machine|espresso)/, 'home-espresso-machines', 'Home Espresso Machines'],
    [/(machine|grinder).*(office|work|cafe|commercial|shop)|commercial/, 'commercial-espresso-machines', 'Commercial Espresso Machines'],
    [/filter coffee|drip (machine|coffee|brewer)|batch brew/, 'filter-coffee-machines', 'Filter Coffee Machines'],
    [/pour ?over|v60|dripper/, 'pour-overs', 'Pour Overs'],
    [/cold brew|iced coffee/, 'cold-brew', 'Cold Brew'],
    [/decaf/, 'decaf-collection', 'Decaf Specialty Coffee'],
    [/gift|present|for (him|her|dad|mum|mom)/, 'bundles-gift-sets', 'Gifts'],
    [/cheap|budget|deal|discount|sale|offer/, 'offers', 'Offers'],
    [/best ?sell|popular|top rated/, 'monthly-best-sellers', 'Monthly Best Sellers'],
    [/new (arrival|in|product)|latest/, 'new-arrivals', 'New Arrivals'],
    [/subscription|subscribe/, 'subscription-boxes', 'Subscription Boxes'],
    [/capsule|pod|nespresso/, 'shop-coffee-capsules', 'Coffee Capsules'],
    [/hand ?grinder|manual grinder|travel grinder/, 'manual-grinders', 'Manual Grinders'],
    [/single ?dose/, 'single-dose-grinders', 'Single-Dose Grinders'],
    [/arabic|qahwa|dallah|قهوه/, 'arabic-coffee', 'Arabic Coffee'],
    [/turkish/, 'turkish-coffee', 'Turkish Coffee'],
    [/light roast/, 'light-roast', 'Light Roast'],
    [/dark roast/, 'dark-roast-1', 'Dark Roast'],
    [/fruity|fruit forward|berry/, 'fruit-forward', 'Fruit Forward'],
    [/chocolat|nutty|choco/, 'nutty-chocolate', 'Nutty / Chocolate']
  ];

  function dl(a, b, max) {
    var al = a.length, bl = b.length;
    if (Math.abs(al - bl) > max) return max + 1;
    if (a === b) return 0;
    var prev2 = null, prev = [], cur, i, j;
    for (j = 0; j <= bl; j++) prev[j] = j;
    for (i = 1; i <= al; i++) {
      cur = [i];
      var best = i;
      for (j = 1; j <= bl; j++) {
        var cost = a.charCodeAt(i - 1) === b.charCodeAt(j - 1) ? 0 : 1;
        var v = Math.min(cur[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) v = Math.min(v, prev2[j - 2] + 1);
        cur[j] = v; if (v < best) best = v;
      }
      if (best > max) return max + 1;
      prev2 = prev; prev = cur;
    }
    return prev[bl];
  }
  function anagram(a, b) {
    return a.length === b.length && a.split('').sort().join('') === b.split('').sort().join('');
  }

  /* ----------------------------------------------------------------------
     Phonetic skeleton matching.

     One mechanism fixes two problems at once. Reduce a word to its consonant
     skeleton — drop vowels and weak letters, fold letters that sound alike —
     and badly misspelled words collapse onto the same key as the real one:

       Feelow / Fellow      -> fl        Roket / Rocket       -> rkt
       Simoneli / Simonelli -> smnl      Xbllloom / xBloom    -> ksblm
       malkhonig/Mahlkonig  -> mlkng

     Transliterate Arabic to Latin first and the same key works across scripts,
     because Arabic script omits short vowels anyway and the skeleton drops the
     rest:  توباكو -> twbakw -> tbk  ==  tobacco -> tbk
            كولومبيا -> kwlwmbya -> klmb == colombia -> klmb
     That is what lets an Arabic query reach an English catalogue.
     ---------------------------------------------------------------------- */

  var AR2LAT = {
    'ا': 'a', 'أ': 'a', 'إ': 'a', 'آ': 'a', 'ٱ': 'a', 'ب': 'b', 'ت': 't', 'ث': 'th',
    'ج': 'j', 'ح': 'h', 'خ': 'kh', 'د': 'd', 'ذ': 'th', 'ر': 'r', 'ز': 'z',
    'س': 's', 'ش': 'sh', 'ص': 's', 'ض': 'd', 'ط': 't', 'ظ': 'z', 'ع': 'a',
    'غ': 'gh', 'ف': 'f', 'ق': 'k', 'ك': 'k', 'ل': 'l', 'م': 'm', 'ن': 'n',
    'ه': 'h', 'ة': 'h', 'و': 'w', 'ي': 'y', 'ى': 'y', 'ء': '', 'ئ': 'y', 'ؤ': 'w',
    'پ': 'b', 'چ': 'ch', 'ژ': 'z', 'گ': 'g', 'ڤ': 'f'
  };
  var AR_RE = /[؀-ۿ]/;

  function isArabic(s) { return AR_RE.test(s); }

  function translitAr(s) {
    var out = '';
    for (var i = 0; i < s.length; i++) {
      var c = s[i];
      out += (AR2LAT[c] !== undefined) ? AR2LAT[c] : c;
    }
    return out;
  }

  function skeletonKey(s) {
    if (!s) return '';
    var t = isArabic(s) ? translitAr(s) : s;
    t = t.toLowerCase()
      .replace(/ph/g, 'f').replace(/gh/g, 'g').replace(/sh/g, 's')
      .replace(/th/g, 't').replace(/ck/g, 'k').replace(/ch/g, 'k')
      .replace(/x/g, 'ks').replace(/[cq]/g, 'k').replace(/j/g, 'g')
      .replace(/p/g, 'b')                    // Arabic has no p; b and p interchange
      .replace(/[aeiouwyh]/g, '')            // vowels and weak consonants carry no signal
      .replace(/[^a-z]/g, '')
      .replace(/(.)\1+/g, '$1');             // collapse doubles
    return t;
  }

  // Arabic words that are words, not transliterations — these need meaning, not sound.
  var AR_CONCEPT = {
    'قهوه': ['coffee', 'beans'], 'قهوا': ['coffee'], 'بن': ['beans', 'coffee'],
    'حبوب': ['beans'], 'حبه': ['beans'], 'محمصه': ['roastery'], 'تحميص': ['roast'],
    'مطحنه': ['grinder'], 'طاحونه': ['grinder'], 'مطحن': ['grinder'],
    'مكينه': ['machine'], 'ماكينه': ['machine'], 'اله': ['machine'],
    'اسبريسو': ['espresso'], 'اكسبريسو': ['espresso'],
    'اكواب': ['cup', 'cups', 'glass'], 'كوب': ['cup', 'cups'], 'فنجان': ['cup'],
    'فناجين': ['cup', 'cups'], 'كاسات': ['glass', 'cup'],
    'فلتر': ['filter'], 'فلاتر': ['filter', 'filters'], 'ورق': ['paper', 'filter'],
    'كبسولات': ['capsule', 'capsules'], 'كبسوله': ['capsule'],
    'تنظيف': ['cleaning', 'cleaner'], 'منظف': ['cleaning', 'cleaner'],
    'غلايه': ['kettle'], 'ابريق': ['kettle', 'jug'], 'كتل': ['kettle'],
    'ميزان': ['scale'], 'حليب': ['milk'], 'شاي': ['tea'], 'سكر': ['sugar'],
    'هديه': ['gift', 'gifts'], 'هدايا': ['gift', 'gifts'],
    'تركي': ['turkish'], 'تركيه': ['turkish'], 'عربي': ['arabic'], 'عربيه': ['arabic'],
    'بارد': ['cold', 'brew'], 'مثلج': ['cold', 'brew'], 'مطحون': ['ground'],
    'مختصه': ['specialty'], 'مختص': ['specialty'], 'اخضر': ['green'],
    'دلاله': ['dallah'], 'دله': ['dallah'], 'قشر': ['cascara'],
    // seen in real GA4 queries: xBloom is the store's most-searched product
    'بلوم': ['xbloom', 'bloom'], 'اكس': ['xbloom'], 'اكسبلوم': ['xbloom'],
    'توباكو': ['tobacco'], 'تباكو': ['tobacco']
  };
  var AR_CONCEPT_KEYS = Object.keys(AR_CONCEPT);

  function arabicConcepts(qt) {
    if (AR_CONCEPT[qt]) return AR_CONCEPT[qt];
    // a doubled letter or a dropped one shouldn't lose the meaning (ممكينه -> مكينه)
    for (var i = 0; i < AR_CONCEPT_KEYS.length; i++) {
      var k = AR_CONCEPT_KEYS[i];
      if (Math.abs(k.length - qt.length) <= 1 && dl(qt, k, 1) <= 1) return AR_CONCEPT[k];
    }
    return null;
  }

  /* ----------------------------------------------------------------------
     As-you-type closeness.

     A dropdown must never go blank while someone is still typing. "xbllloo" is
     mid-word and mangled: too far for edit distance, one letter short of the
     right skeleton, not a prefix of anything. Two cheap measures cover it.

     1. Longest usable prefix — walk the typed word back a letter at a time
        until some catalogue term starts with what's left. "xbllloo" -> "xbl"
        -> xBloom. This is what makes each keystroke keep working.
     2. Jaro-Winkler — a similarity score that rewards a shared opening and
        tolerates transpositions, used as a last-resort sweep so there is
        always something to show.
     ---------------------------------------------------------------------- */

  function jaro(a, b) {
    if (a === b) return 1;
    var al = a.length, bl = b.length;
    if (!al || !bl) return 0;
    var range = Math.max(0, Math.floor(Math.max(al, bl) / 2) - 1);
    var am = new Array(al), bm = new Array(bl), matches = 0, i, j;
    for (i = 0; i < al; i++) {
      var lo = Math.max(0, i - range), hi = Math.min(i + range + 1, bl);
      for (j = lo; j < hi; j++) {
        if (bm[j] || a.charAt(i) !== b.charAt(j)) continue;
        am[i] = bm[j] = true; matches++; break;
      }
    }
    if (!matches) return 0;
    var t = 0, k = 0;
    for (i = 0; i < al; i++) {
      if (!am[i]) continue;
      while (!bm[k]) k++;
      if (a.charAt(i) !== b.charAt(k)) t++;
      k++;
    }
    t /= 2;
    return (matches / al + matches / bl + (matches - t) / matches) / 3;
  }

  function jaroWinkler(a, b) {
    var j = jaro(a, b);
    if (j < 0.7) return j;
    var p = 0;
    while (p < 4 && p < a.length && p < b.length && a.charAt(p) === b.charAt(p)) p++;
    return j + p * 0.1 * (1 - j);
  }

  // Longest prefix of the typed word that anything in the catalogue starts with.
  function prefixFallback(qt, limit) {
    var out = [];
    for (var len = qt.length - 1; len >= 3; len--) {
      var p = qt.slice(0, len);
      vocab.forEach(function (_, term) {
        if (out.length < limit && term.indexOf(p) === 0) out.push({ t: term, p: len });
      });
      if (out.length) return out;
    }
    return out;
  }

  // Last resort: the closest thing in the catalogue, whatever was typed.
  function nearestTerms(qt, limit, floor) {
    var best = [];
    vocab.forEach(function (_, term) {
      if (Math.abs(term.length - qt.length) > 5) return;
      var sim = jaroWinkler(qt, term);
      if (sim < floor) return;
      best.push({ t: term, s: sim });
    });
    best.sort(function (a, b) { return b.s - a.s; });
    return best.slice(0, limit);
  }

  var DATA = null, vocab = null, byLen = null, docsN = 0, entities = null, ready = false;
  var bySkel = null, skelByLen = null;
  var F = { T: 6.0, V: 4.2, P: 2.6, G: 1.8 };

  function tokenize(s, known) {
    var base = phrases(norm(s));
    if (!base) return [];
    var out = [];
    base.split(' ').forEach(function (t) {
      if (!t) return;
      out.push(t);
      if (known && known(t)) return;
      var parts = t.match(/[a-z؀-ۿ]+|[0-9]+/g);
      if (parts && parts.length > 1) parts.forEach(function (p) { if (p.length > 2) out.push(p); });
    });
    return out;
  }
  // "booncoffee" and "cafe lat" are the same mistake in opposite directions:
  // a space that shouldn't be there, or one that should. Both are common enough
  // to be worth handling, and both are decidable straight from the vocabulary.
  function splitCompound(t) {
    if (!vocab || vocab.has(t) || t.length < 6) return null;
    for (var i = 3; i <= t.length - 3; i++) {
      var a = t.slice(0, i), b = t.slice(i);
      if (vocab.has(a) && vocab.has(b)) return [a, b];
    }
    return null;
  }

  function qTokens(s) {
    var known = function (t) { return vocab && vocab.has(t); };
    var ts = tokenize(s, known).filter(function (t) { return !STOP[t]; });
    ts = ts.filter(function (t, i, a) { return a.indexOf(t) === i; });
    if (!ts.length) ts = tokenize(s, known).filter(function (t, i, a) { return a.indexOf(t) === i; });
    if (!vocab) return ts;

    // join a pair that is only a real word when run together ("cafe lat")
    var joined = [];
    for (var i = 0; i < ts.length; i++) {
      if (i < ts.length - 1 && !vocab.has(ts[i]) && vocab.has(ts[i] + ts[i + 1])) {
        joined.push(ts[i] + ts[i + 1]); i++;
      } else joined.push(ts[i]);
    }

    // split one that is two words run together ("booncoffee")
    var out = [];
    joined.forEach(function (t) {
      var parts = splitCompound(t);
      if (parts) out.push(parts[0], parts[1]); else out.push(t);
    });
    return out.filter(function (t, i, a) { return a.indexOf(t) === i; });
  }

  function addPost(term, d, w) {
    var e = vocab.get(term);
    if (!e) { e = { df: 0, post: new Map() }; vocab.set(term, e); }
    var c = e.post.get(d);
    if (c === undefined) { e.post.set(d, w); e.df++; }
    else if (w > c) e.post.set(d, w);
  }

  // Built in slices with a yield between each, so indexing never occupies the
  // main thread long enough to be a "long task" (50ms) even on a slow phone.
  // Queries before ready simply pass through to native search, so slicing the
  // build costs nothing in correctness.
  // setTimeout(0), not requestIdleCallback: rIC waits for genuine idle and in a
  // background or throttled tab that never comes, which pushed the index from
  // ~50ms to ~6s of wall time. A macrotask yield is ~4ms and predictable.
  function yieldToBrowser() {
    return new Promise(function (resolve) { setTimeout(resolve, 0); });
  }

  function buildProducts(data, from, size) {
    var end = Math.min(from + size, data.products.length);
    for (var d = from; d < end; d++) {
      var p = data.products[d];
      tokenize(p.t).forEach(function (t) { addPost(t, d, F.T); });
      if (p.v >= 0) tokenize(data.vendors[p.v]).forEach(function (t) { addPost(t, d, F.V); });
      if (p.p >= 0) tokenize(data.types[p.p]).forEach(function (t) { addPost(t, d, F.P); });
      (p.g || []).forEach(function (g) { tokenize(g).forEach(function (t) { addPost(t, d, F.G); }); });
    }
    return end;
  }

  function build(data) {
    DATA = data; vocab = new Map(); byLen = new Map(); docsN = data.products.length;
    shelves = null;
    expCache.clear();
    var at = 0, SLICE_MS = 12;

    // Work to a time budget rather than a fixed count, so a slow phone takes
    // more slices instead of one long task.
    function step() {
      var deadline = performance.now() + SLICE_MS;
      while (at < data.products.length && performance.now() < deadline) {
        at = buildProducts(data, at, 50);
      }
      if (at < data.products.length) return yieldToBrowser().then(step);
      return yieldToBrowser().then(function () { finishBuild(data); });
    }
    return step();
  }

  function finishBuild(data) {
    vocab.forEach(function (_, term) {
      var L = term.length;
      if (!byLen.has(L)) byLen.set(L, []);
      byLen.get(L).push(term);
    });

    bySkel = new Map(); skelByLen = new Map();
    vocab.forEach(function (_, term) {
      var k = skeletonKey(term);
      if (k.length < 2) return;
      if (!bySkel.has(k)) {
        bySkel.set(k, []);
        var L = k.length;
        if (!skelByLen.has(L)) skelByLen.set(L, []);
        skelByLen.get(L).push(k);
      }
      bySkel.get(k).push(term);
    });
    entities = [];
    data.brands.forEach(function (b) { entities.push({ k: 'brand', t: b.t, n: b.n, u: '/collections/all-brands', toks: tokenize(b.t) }); });
    data.collections.forEach(function (c) { entities.push({ k: 'collection', t: c.t, n: c.n, u: '/collections/' + c.h, toks: tokenize(c.t) }); });
    data.articles.forEach(function (a) { entities.push({ k: 'guide', t: a.t, u: '/blogs/specialty-coffee-equipment-beanburds-blog/' + a.h, toks: tokenize(a.t) }); });
    ready = true;
  }

  function maxDist(len) { return len <= 2 ? 0 : (len <= 7 ? 1 : 2); }

  var expCache = new Map();
  function expand(qt) {
    if (expCache.has(qt)) return expCache.get(qt);
    var out = [], seen = new Set();
    function push(term, w, corr) { if (seen.has(term)) return; seen.add(term); out.push({ t: term, w: w, c: corr }); }
    var isKnown = vocab.has(qt);
    if (isKnown) push(qt, 1.0, null);
    // A token can exist in the catalogue and still be a typo for something far
    // more popular — "carel" is a real controls brand and also how people
    // misspell Cartel. If the exact term is rare, offer the common one too.
    var rareKnown = isKnown && vocab.get(qt).df <= 4;
    if (qt.length >= 2) {
      var n = 0;
      vocab.forEach(function (_, term) {
        if (n > 80) return;
        if (term.length > qt.length && term.indexOf(qt) === 0) { push(term, 0.90 * (0.55 + 0.45 * (qt.length / term.length)), null); n++; }
      });
    }
    if (!isKnown || rareKnown) {
      var md = maxDist(qt.length), cands = [];
      if (md > 0) {
        for (var L = qt.length - md; L <= qt.length + md; L++) {
          var bucket = byLen.get(L); if (!bucket) continue;
          for (var i = 0; i < bucket.length; i++) {
            var term = bucket[i]; if (seen.has(term)) continue;
            var d = dl(qt, term, md); if (d > md) continue;
            var tr = (d === 1 && anagram(qt, term));
            if (qt.length <= 3 && !tr) continue;
            var w = tr ? 0.92 : (0.72 - 0.20 * (d - 1)) * (1 - d / (qt.length + 2));
            // People misspell towards things that exist in quantity. When two
            // corrections are equally close, prefer the better-represented one
            // ("carel" -> Cartel, 14 products, not "care", 2).
            w *= 1 + 0.10 * Math.log(1 + vocab.get(term).df);
            cands.push({ t: term, w: Math.max(w, 0.3), d: d });
          }
        }
      }
      if (qt.length >= 4) {
        vocab.forEach(function (_, term) {
          if (seen.has(term) || term.length <= qt.length) return;
          if (term.indexOf(qt) > 0) cands.push({ t: term, w: 0.58 * (qt.length / term.length) + 0.18, d: 9 });
        });
      }
      cands.sort(function (a, b) { return b.w - a.w; });
      cands.slice(0, 40).forEach(function (c) {
        // when the typed word is real, a correction is a suggestion, not a fix
        push(c.t, rareKnown ? Math.min(c.w, 0.6) : c.w, c.d <= 2 ? c.t : null);
      });
    }
    var syn = SYN[qt];
    if (syn) syn.forEach(function (s) { if (vocab.has(s)) push(s, 0.78, null); });

    // Arabic words carrying meaning rather than sound
    var conceptHit = false;
    if (isArabic(qt)) {
      var concepts = arabicConcepts(qt);
      if (concepts) {
        concepts.forEach(function (c) { if (vocab.has(c)) { push(c, 0.85, null); conceptHit = true; } });
      }
    }

    // Phonetic skeleton — the tier that catches what edit distance cannot.
    // Deliberately low weight: it is broad, so it should lose to a real match.
    var arabic = isArabic(qt);
    var skel = skeletonKey(qt);
    if (skel.length >= 3 && bySkel && !conceptHit) {
      // A shared skeleton alone is too loose for Latin input — "carel" and
      // "cartridge" can collapse together. Require the candidate to also be
      // close as written. Arabic is exempt: the skeleton IS the evidence there,
      // since the two scripts never look alike letter for letter.
      var plausible = function (term) {
        if (arabic) return true;
        var d = dl(qt, term, 4);
        return d <= Math.max(1, Math.floor(Math.max(qt.length, term.length) * 0.42));
      };

      var exactSkel = bySkel.get(skel);
      if (exactSkel) {
        exactSkel.forEach(function (term) {
          if (!plausible(term)) return;
          push(term, isKnown ? 0.45 : (arabic ? 0.82 : 0.72), isKnown ? null : term);
        });
      }

      // near-miss skeletons, Latin only and only for longer words
      if (!isKnown && !arabic && skel.length >= 5) {
        var near = [];
        for (var sl = skel.length - 1; sl <= skel.length + 1; sl++) {
          var sb = skelByLen.get(sl); if (!sb) continue;
          for (var si = 0; si < sb.length && near.length < 6; si++) {
            if (sb[si] !== skel && dl(skel, sb[si], 1) <= 1) near.push(sb[si]);
          }
        }
        near.forEach(function (k) {
          (bySkel.get(k) || []).forEach(function (term) {
            if (plausible(term)) push(term, 0.48, term);
          });
        });
      }
    }

    // Nothing landed yet — the word is mid-typed or badly mangled. Fall back to
    // closeness rather than returning an empty dropdown.
    if (!out.length && qt.length >= 3 && !arabic) {
      prefixFallback(qt, 12).forEach(function (c) {
        push(c.t, 0.40 + 0.30 * (c.p / qt.length), c.t);
      });
    }
    if (!out.length && qt.length >= 3) {
      nearestTerms(qt, 8, 0.78).forEach(function (c) {
        push(c.t, 0.34 + 0.30 * c.s, c.t);
      });
    }

    expCache.set(qt, out);
    return out;
  }

  function search(q, limit) {
    limit = limit || 8;
    var out = { products: [], brands: [], collections: [], guides: [], intent: null, correction: null, total: 0 };
    if (!ready) return out;
    var nq = phrases(norm(q)), qts = qTokens(q);
    if (!qts.length) return out;

    var scores = new Map(), hits = new Map(), corr = new Map();
    qts.forEach(function (qt, qi) {
      var exact = vocab.has(qt), best = null;
      expand(qt).forEach(function (tw) {
        var e = vocab.get(tw.t); if (!e) return;
        var idf = Math.log(1 + docsN / (1 + e.df));
        e.post.forEach(function (fw, d) {
          scores.set(d, (scores.get(d) || 0) + fw * tw.w * idf);
          var h = hits.get(d); if (!h) { h = new Set(); hits.set(d, h); }
          h.add(qi);
        });
        if (!exact && tw.c && tw.w >= 0.6 && (!best || tw.w > best.w)) best = tw;
      });
      if (best) corr.set(qt, best.t);
    });

    var res = [], partial = [];
    scores.forEach(function (s, d) {
      var p = DATA.products[d];
      var cov = (hits.get(d) || { size: 0 }).size / qts.length;
      var weak = (qts.length > 1 && cov < 0.5);
      var sc = s * Math.pow(cov, 2.2), nt = norm(p.t);
      if (nt === nq) sc *= 3.2;
      else if (nt.indexOf(nq) === 0) sc *= 2.1;
      else if (nq.length > 2 && nt.indexOf(nq) >= 0) sc *= 1.7;
      sc *= (1 + 0.30 * Math.exp(-nt.length / 34));
      if (p.i) sc *= 1.06;
      (weak ? partial : res).push({ d: d, s: sc });
    });
    if (!res.length && partial.length) res = partial;
    res.sort(function (a, b) { return b.s - a.s; });
    out.total = res.length;
    out.products = res.slice(0, limit).map(function (r) {
      var p = DATA.products[r.d];
      return {
        id: p.id, title: p.t, handle: p.h || '',
        vendor: p.v >= 0 ? DATA.vendors[p.v] : '',
        img: p.i ? p.i.replace('~', DATA.cdn) : '',
        price: p.c || '',
        rawType: p.p >= 0 ? DATA.types[p.p] : ''
      };
    });

    var ents = [];
    entities.forEach(function (en) {
      var sc = 0, cov = 0;
      qts.forEach(function (qt) {
        var best = 0;
        en.toks.forEach(function (et) {
          if (et === qt) best = Math.max(best, 1);
          else if (qt.length >= 2 && et.indexOf(qt) === 0) best = Math.max(best, 0.85);
          else {
            var md = maxDist(qt.length);
            if (md > 0 && Math.abs(et.length - qt.length) <= md) {
              var d = dl(qt, et, md);
              if (d <= md) {
                if (d === 1 && anagram(qt, et)) best = Math.max(best, 0.8);
                else if (qt.length > 3) best = Math.max(best, 0.55);
              }
            }
          }
        });
        if (best > 0) { sc += best; cov++; }
      });
      if (!cov || cov / qts.length < 0.5) return;
      var s = sc * Math.pow(cov / qts.length, 2), et2 = norm(en.t);
      if (et2 === nq) s *= 3; else if (et2.indexOf(nq) === 0) s *= 1.8;
      if (en.n) s *= (1 + Math.min(en.n, 200) / 700);
      ents.push({ e: en, s: s });
    });
    ents.sort(function (a, b) { return b.s - a.s; });
    function pick(k, n) {
      return ents.filter(function (x) { return x.e.k === k; }).slice(0, n)
        .map(function (x) { return { title: x.e.t, url: x.e.u }; });
    }
    out.brands = pick('brand', 2);
    out.collections = pick('collection', 2);
    out.guides = pick('guide', 1);

    for (var i = 0; i < INTENT.length; i++) {
      if (INTENT[i][0].test(nq)) { out.intent = { title: INTENT[i][2], url: '/collections/' + INTENT[i][1] }; break; }
    }

    if (corr.size && out.products.length) {
      var rebuilt = qts.slice(), changed = false;
      qts.forEach(function (qt, i) {
        if (corr.has(qt) && corr.get(qt) !== qt) { rebuilt[i] = corr.get(qt); changed = true; }
      });
      if (changed) out.correction = rebuilt.join(' ');
    }
    return out;
  }

  /* ======================================================================
     1b. Sub-category resolver

     Results are grouped under the shelf each product belongs to. The only
     per-product taxonomy in the index is Shopify's productType, and it is not
     clean enough to print on a heading: 44 distinct values, of which ~23 are
     one-offs ("Cup", "Switch", "Coffmeter", "Filter paper") and a handful are
     wrong (the Fellow Ode grinder is filed under Coffee Machines).

     A heading that lies is worse than no heading, so every product is resolved
     onto one of 22 real shelves: rename the one-offs, distrust a small set of
     vague types and re-read those from the title, and let the two accessory
     catch-alls yield when a title names a device outright.

     Deterministic and local. The catalogue itself should be corrected at
     source — see beanburds-product-type-fixes.xlsx — after which most of this
     becomes a no-op rather than a load-bearing layer.
     ====================================================================== */
  var SHELVES = [
    'Home Espresso Machines', 'Commercial Espresso Machines', 'Office Coffee Machines',
    'Home Coffee Makers', 'Commercial Brewing', 'Manual Brewers',
    'Home Grinders', 'Commercial Grinders',
    'Kettles', 'Scales & Measuring', 'Tampers & Distribution',
    'Milk Pitchers & Frothing', 'Filters & Papers', 'Cups & Drinkware',
    'Coffee Beans', 'Coffee Capsules & Drip Bags',
    'Water Filtration', 'Cleaning & Maintenance', 'Kitchen Appliances',
    'Bundles & Gift Sets', 'Barista Accessories', 'Coffee Accessories'
  ];
  var CANON = {
    'coffee capsules': 'Coffee Capsules & Drip Bags',
    'cleaning products': 'Cleaning & Maintenance',
    'distribution tool': 'Tampers & Distribution',
    'filter paper': 'Filters & Papers',
    'electric kettle': 'Kettles', 'kettle': 'Kettles',
    'cup': 'Cups & Drinkware',
    'coffee dripper': 'Manual Brewers', 'v60 set': 'Manual Brewers',
    'switch': 'Manual Brewers', 'coffee brewer': 'Manual Brewers',
    'coffmeter': 'Scales & Measuring', 'digital meter': 'Scales & Measuring',
    'cool meter': 'Scales & Measuring',
    'aromas kit': 'Coffee Accessories'
  };
  // value = where the product lands if no title pattern matches
  var WEAK_TYPE = {
    '': 'Coffee Accessories', 'accessories': 'Coffee Accessories',
    'grinders': 'GRINDER', 'grinder': 'GRINDER',
    'coffee machines': 'MACHINE', 'coffee machines and equipment': 'MACHINE',
    'brewing equipment': 'Manual Brewers', 'drip coffee makers': 'Home Coffee Makers'
  };
  var PRO_VENDOR = {
    'la marzocco': 1, 'victoria arduino': 1, 'nuova simonelli': 1, 'mahlkonig': 1,
    'eureka': 1, 'fiorenzato': 1, 'compak': 1, 'anfim': 1, 'mazzer': 1, 'ceado': 1,
    'sanremo': 1, 'marco': 1, 'saba trading': 1, 'slayer': 1, 'synesso': 1
  };
  var INFER = [
    [/moccamaster|batch brew|drip coffee maker|filter coffee machine/, 'Home Coffee Makers'],
    [/filter paper|paper filter|\bfilters?\b(?!.*water)/, 'Filters & Papers'],
    [/water filter|\bbwt\b|softener|resin|limescale/, 'Water Filtration'],
    [/grinder|burr set|grinding/, 'GRINDER'],
    [/kettle/, 'Kettles'],
    [/pitcher|frothing|milk jug|latte art pen/, 'Milk Pitchers & Frothing'],
    [/tamper|distribut|\bwdt\b|leveler|leveller|puck screen/, 'Tampers & Distribution'],
    [/scale|refractometer|\btds\b|moisture|thermometer|\btimer\b/, 'Scales & Measuring'],
    [/syphon|siphon|french press|pour ?over|dripper|v60|chemex|aeropress|clever|kalita|moka|percolator|cold brew|\bbrewer\b/, 'Manual Brewers'],
    [/espresso machine|coffee machine/, 'MACHINE'],
    [/toast|\boven\b|juicer|blender|microwave|waffle|grill|air fryer|risotto|rice cooker|pressure cook|ice cream|paradice|smart scoop|infizz|fusion cap|sparkling|citrus press|fast slow|combi wave|fresh furious|super q|nutri/, 'Kitchen Appliances'],
    [/clean|cafiza|dezcal|descal|puly|brush|detergent|tablet/, 'Cleaning & Maintenance'],
    [/\bcups?\b|\bmug\b|tumbler|keepcup|carafe|glass|saucer/, 'Cups & Drinkware'],
    [/valve|gasket|portafilter|group ?head|shower screen|spring|e61|steam wand|\bpump\b/, 'Barista Accessories'],
    [/keychain|key chain|apron|t-?shirt|sticker|poster|\bkit\b|\bbag\b/, 'Coffee Accessories']
  ];
  // Sage's non-coffee range — toasters, ovens, juicers, an ice-cream maker, a
  // pressure cooker — was loaded onto Barista Accessories wholesale.
  var SOFT_TYPE = { 'barista accessories': 1, 'coffee accessories': 1 };
  var DEVICE = /\brefractometer\b|\bcoffee scale\b|\btamper\b|\bdistributor\b|\bkettle\b|\bmilk pitcher\b/;
  var NOT_THE_DEVICE = /\bcase\b|\bbag\b|\bcover\b|cleaner|\bstand\b|holder|\bmat\b|brush|cloth|pouch|\bspare\b|\bhandle\b/;
  var KITCHEN = /\btoast|\boven\b|juicer|blender|microwave|waffle|grill\b|air fryer|risotto|rice cooker|pressure cook|ice cream|paradice|smart scoop|infizz|fusion cap|sparkling|citrus press|fast slow|combi wave|fresh furious|super q/;

  function plain(s) {
    return (s || '').toString().toLowerCase().replace(/[^a-z0-9]+/g, ' ').replace(/\s+/g, ' ').trim();
  }

  function categorise(rawType, title, vendor) {
    var raw = plain(rawType), pro = !!PRO_VENDOR[plain(vendor)], nt = plain(title);
    function pick(hit) {
      if (hit === 'GRINDER') return pro ? 'Commercial Grinders' : 'Home Grinders';
      if (hit === 'MACHINE') return pro ? 'Commercial Espresso Machines' : 'Home Espresso Machines';
      return hit;
    }
    var soft = SOFT_TYPE[raw] && (DEVICE.test(nt) || KITCHEN.test(nt)) && !NOT_THE_DEVICE.test(nt);
    if (!WEAK_TYPE.hasOwnProperty(raw) && !soft) {
      if (CANON[raw]) return CANON[raw];
      for (var i = 0; i < SHELVES.length; i++) if (plain(SHELVES[i]) === raw) return SHELVES[i];
    }
    var hay = nt + ' ' + plain(vendor);
    for (var j = 0; j < INFER.length; j++) if (INFER[j][0].test(hay)) return pick(INFER[j][1]);
    return pick(WEAK_TYPE.hasOwnProperty(raw) ? WEAK_TYPE[raw] : 'Coffee Accessories');
  }

  // handle -> shelf, built once the index is ready. 1,161 entries, ~1ms.
  var shelves = null;
  function shelfFor(handle) {
    if (!handle) return '';
    if (!shelves) {
      shelves = new Map();
      if (!DATA) return '';
      DATA.products.forEach(function (p) {
        if (!p.h) return;
        shelves.set(p.h, categorise(
          p.p >= 0 ? DATA.types[p.p] : '', p.t, p.v >= 0 ? DATA.vendors[p.v] : ''
        ));
      });
    }
    return shelves.get(handle) || '';
  }

  /* ======================================================================
     2. Index loading (lazy — never on first paint)
     ====================================================================== */
  var loading = null;
  function loadIndex() {
    if (loading) return loading;
    if (!CFG.indexUrl) { log('no index url'); return Promise.resolve(false); }
    loading = fetch(CFG.indexUrl, { credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (j) {
        if (!j || !j.products) return false;
        var t0 = performance.now();
        return build(j).then(function () {
          log('index ready', j.products.length, 'products in', Math.round(performance.now() - t0), 'ms');
          return true;
        });
      })
      .catch(function (e) { log('index failed', e); return false; });
    return loading;
  }

  function armLazyLoad() {
    var fired = false;
    function go() { if (fired) return; fired = true; loadIndex(); }
    ['focusin', 'pointerdown', 'keydown'].forEach(function (ev) {
      document.addEventListener(ev, function (e) {
        var t = e.target;
        if (!t || !t.closest) return;
        if (t.closest('search-button, dialog-component, predictive-search-component, [id*="search"], input[type="search"], input[name="q"]')) go();
      }, { passive: true, capture: true });
    });
    // Prefetch only once the page has fully loaded, and only when the browser
    // is idle — the index must never compete with first paint.
    var prefetch = function () {
      if ('requestIdleCallback' in window) requestIdleCallback(go, { timeout: 8000 });
      else setTimeout(go, 3000);
    };
    if (document.readyState === 'complete') setTimeout(prefetch, 1200);
    else window.addEventListener('load', function () { setTimeout(prefetch, 1200); }, { once: true });
  }

  /* ======================================================================
     3. HTML helpers
     ====================================================================== */
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  // The theme's cards carry a second image for the hover swap. In a dropdown it
  // is never shown, so it is a wasted request that also delays the thumbnail
  // people are actually waiting on. Drop it and fetch the rest immediately.
  /* ----------------------------------------------------------------------
     Instant results.

     Shopify re-renders the predictive-search Liquid section on the server for
     every keystroke — measured at a median of 814ms on this store. The local
     index answers the same query in under a millisecond, so paint from it
     immediately and swap in Shopify's markup when it lands.

     The markup below deliberately uses the theme's own class names, so the
     local rows inherit the theme's styling and the swap is invisible.
     ---------------------------------------------------------------------- */

  function money(v) {
    if (!v) return '';
    var parts = String(v).split('.');
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + (parts[1] ? '.' + parts[1] : '');
  }

  function localCardsHTML(products) {
    return products.map(function (p) {
      var href = p.handle ? '/products/' + p.handle : (routes().search + '?q=' + encodeURIComponent(p.title));
      return '<li class="predictive-search-results__card predictive-search-results__card--product"' +
        ' ref="resultsItems[]" on:keydown="/onSearchKeyDown">' +
        '<div class="resource-card__wrapper"><div class="resource-card">' +
        '<a class="resource-card__link" href="' + esc(href) + '">' +
        '<span class="visually-hidden">' + esc(p.title) + '</span></a>' +
        '<div class="resource-card__media">' +
        (p.img ? '<img class="resource-card__image" src="' + esc(p.img) + '" alt="" loading="eager" fetchpriority="high">' : '') +
        '</div>' +
        '<div class="resource-card__content">' +
        '<p class="resource-card__title paragraph">' + esc(p.title) + '</p>' +
        '<div><div class="price__regular"><span class="price">' + esc(money(p.price)) + '</span></div></div>' +
        '</div></div></div></li>';
    }).join('');
  }

  function localDropdownHTML(res) {
    if (!res.products.length) return null;
    return '<div id="predictive-search-results" class="predictive-search-dropdown" role="listbox" data-bb-local>' +
      '<div class="predictive-search-results__inner">' +
      '<div class="predictive-search-results__products">' +
      '<h4 class="predictive-search-results__title">Products</h4>' +
      '<ul class="predictive-search-results__list predictive-search-results__wrapper-products list-unstyled">' +
      localCardsHTML(res.products) +
      '</ul></div></div></div>';
  }

  function tuneCardImages(root) {
    [].slice.call(root.querySelectorAll('.resource-card__image--secondary'))
      .forEach(function (img) { img.remove(); });
    [].slice.call(root.querySelectorAll('.resource-card__image'))
      .forEach(function (img) { img.setAttribute('loading', 'eager'); img.setAttribute('fetchpriority', 'high'); });
  }
  function productCount(doc) { return doc.querySelectorAll('.predictive-search-results__card--product').length; }

  /* ----------------------------------------------------------------------
     Group the rendered cards under their sub-category.

     Works on whatever markup is already there — the instant local render and
     Shopify's own section both produce the same card classes — so the cards
     themselves are moved, never rebuilt. Nothing about a card's appearance
     changes; only the headings above them.

     Four headings is as much structure as a dropdown can carry before it reads
     as a wall, so anything past the fourth shelf stays behind "view all".
     ---------------------------------------------------------------------- */
  var MAX_GROUPS = 4;

  function cardHandle(card) {
    var a = card.querySelector('.resource-card__link');
    var m = a && (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
    if (!m) return '';
    try { return decodeURIComponent(m[1]); } catch (e) { return m[1]; }
  }

  function groupHeading(doc, shelf, count) {
    var h = doc.createElement('h4');
    h.className = 'predictive-search-results__title';
    h.setAttribute('data-bb-shelf', '');
    // the theme's title class sets overflow-wrap:break-word, which would snap
    // "Machines" mid-word on a narrow screen
    h.style.overflowWrap = 'normal';
    h.style.wordBreak = 'normal';
    h.textContent = shelf;
    if (count > 1) {
      var n = doc.createElement('span');
      n.textContent = count;
      n.setAttribute('style',
        'margin-left:7px;padding:1px 6px;border-radius:999px;font-size:10px;' +
        'font-weight:700;letter-spacing:.04em;background:rgba(0,0,0,.06);vertical-align:middle');
      h.appendChild(n);
    }
    return h;
  }

  /* The response has usually been grouped already, by decorate() on its way
     through the fetch hook. Flatten it back into one list before topping up
     with local extras, otherwise every extra lands under whichever heading
     happens to come first. */
  function ungroup(root) {
    var blocks = [].slice.call(root.querySelectorAll('[data-bb-grouped]'));
    if (!blocks.length) return;
    var first = blocks[0];
    var list = first.querySelector('.predictive-search-results__wrapper-products');
    if (!list) return;
    blocks.slice(1).forEach(function (b) {
      [].slice.call(b.querySelectorAll('.predictive-search-results__card--product'))
        .forEach(function (c) { list.appendChild(c); });
      if (b.parentNode) b.parentNode.removeChild(b);
    });
    var h = first.querySelector('[data-bb-shelf]');
    if (h) h.textContent = 'Products';        // regroup renames it in a moment
    first.removeAttribute('data-bb-grouped');
  }

  function regroup(root) {
    if (!ready) return;
    var ul = root.querySelector('.predictive-search-results__wrapper-products');
    if (!ul) return;
    var block = ul.parentNode;
    if (!block || block.hasAttribute('data-bb-grouped')) return;

    var cards = [].slice.call(ul.querySelectorAll('.predictive-search-results__card--product'));
    if (!cards.length) return;

    var order = [], by = {};
    cards.forEach(function (c) {
      var s = shelfFor(cardHandle(c));
      if (!s) return;                                   // unknown product: leave the list alone
      if (!by[s]) { by[s] = []; order.push(s); }
      by[s].push(c);
    });
    if (!order.length) return;

    var doc = root.ownerDocument || root;

    // One shelf covers everything — name it instead of saying "Products".
    if (order.length === 1) {
      var t = block.querySelector('.predictive-search-results__title');
      if (t) t.parentNode.replaceChild(groupHeading(doc, order[0], 0), t);
      block.setAttribute('data-bb-grouped', '');
      return;
    }

    // The products block sometimes IS the inner wrapper, which also holds the
    // navigation pills — in that case build new blocks around the list rather
    // than cloning and discarding the wrapper.
    var inPlace = block.classList.contains('predictive-search-results__inner');
    var frag = doc.createDocumentFragment();

    order.slice(0, MAX_GROUPS).forEach(function (shelf) {
      var b;
      if (inPlace) {
        b = doc.createElement('div');
        b.className = 'predictive-search-results__products';
      } else {
        b = block.cloneNode(false);
        b.removeAttribute('id');
      }
      b.setAttribute('data-bb-grouped', '');
      b.appendChild(groupHeading(doc, shelf, by[shelf].length));
      var list = ul.cloneNode(false);
      list.removeAttribute('id');
      by[shelf].forEach(function (c) { list.appendChild(c); });
      b.appendChild(list);
      frag.appendChild(b);
    });

    if (inPlace) {
      ul.parentNode.insertBefore(frag, ul);
      ul.parentNode.removeChild(ul);
    } else {
      block.parentNode.insertBefore(frag, block);
      block.parentNode.removeChild(block);
    }
  }

  function pillList(items) {
    if (!items.length) return null;
    var ul = document.createElement('ul');
    ul.className = 'predictive-search-results__list predictive-search-results__wrapper-queries list-unstyled';
    ul.setAttribute('data-bb-pills', '');
    items.forEach(function (it) {
      var li = document.createElement('li');
      li.className = 'predictive-search-results__card--query';
      li.setAttribute('ref', 'resultsItems[]');
      li.setAttribute('on:keydown', '/onSearchKeyDown');
      li.innerHTML = '<a class="pills__pill predictive-search-results__pill" href="' + esc(it.url) +
        '" aria-label="' + esc(it.title) + '"><span>' + esc(it.title) + '</span></a>';
      ul.appendChild(li);
    });
    return ul;
  }

  function noteEl(original, corrected) {
    var p = document.createElement('p');
    p.className = 'predictive-search-results__title';
    p.setAttribute('data-bb-note', '');
    p.style.fontWeight = '400';
    // the theme's title class sets overflow-wrap:break-word, which snaps words
    // mid-word ("Mediu / m"). Labels must never break inside a word.
    p.style.overflowWrap = 'normal';
    p.style.wordBreak = 'normal';
    p.innerHTML = 'Showing results for <strong>' + esc(corrected) + '</strong> · ' +
      '<a href="' + routes().search + '?q=' + encodeURIComponent(original) + '" style="text-decoration:underline">' +
      'search for &ldquo;' + esc(original) + '&rdquo; instead</a>';
    return p;
  }

  function track(name, payload) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(Object.assign({ event: name }, payload || {}));
    } catch (e) { /* analytics must never break search */ }
  }

  /* ======================================================================
     4. Recovery: render OUR matches through the theme's own cards.
        Uses the same id: search the theme already uses for recently-viewed,
        which preserves our relevance order via the section's order_ids path.
     ====================================================================== */
  function fetchByIds(ids, sectionId) {
    var url = new URL(routes().search, location.origin);
    url.searchParams.set('q', ids.map(function (id) { return 'id:' + id; }).join(' OR '));
    url.searchParams.set('resources[type]', 'product');
    url.searchParams.set('section_id', sectionId);
    return window.__bbNativeFetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : null; })
      .catch(function () { return null; });
  }

  // The theme's else-branch labels this block "Recently viewed" and adds a
  // Clear button. Relabel it and strip the control so it reads as results.
  function adaptRecoveredBlock(html, heading) {
    var doc = parse(html);
    var block = doc.getElementById('predictive-search-products');
    if (!block || !block.querySelector('.predictive-search-results__card--product')) return null;
    var clear = block.querySelector('.predictive-search-results__clear');
    if (clear) clear.remove();
    var title = block.querySelector('.predictive-search-results__title');
    if (title) { title.textContent = heading; title.removeAttribute('ref'); }
    block.querySelectorAll('[ref="recentlyViewedItems[]"]').forEach(function (el) { el.setAttribute('ref', 'resultsItems[]'); });
    block.querySelectorAll('[ref="recentlyViewedWrapper"]').forEach(function (el) { el.removeAttribute('ref'); });
    var wrap = block.querySelector('.recently-viewed-wrapper');
    if (wrap) wrap.classList.remove('recently-viewed-wrapper');

    // The theme's id: loop renders one card per id it was given. When Shopify
    // doesn't return one of them the card comes out empty — no image, no title,
    // just a stray price. Drop any card that has no title.
    [].slice.call(block.querySelectorAll('.predictive-search-results__card--product'))
      .forEach(function (card) {
        var t = card.querySelector('.resource-card__title');
        if (!t || !t.textContent.trim()) card.remove();
      });
    if (!block.querySelector('.predictive-search-results__card--product')) return null;

    tuneCardImages(block);
    block.setAttribute('data-bb-recovered', '');
    return block;
  }

  /* ======================================================================
     5. The hook
     ====================================================================== */
  var nativeFetch = window.fetch.bind(window);
  window.__bbNativeFetch = nativeFetch;

  function isPredictive(u) {
    try {
      var url = new URL(u, location.origin);
      if (url.pathname.indexOf(routes().predictive) !== 0) return null;
      var q = url.searchParams.get('q');
      var sid = url.searchParams.get('section_id');
      if (!q || !sid) return null;
      if (q.indexOf('id:') === 0) return null;          // recently-viewed, leave alone
      return { url: url, q: q, sid: sid };
    } catch (e) { return null; }
  }

  window.fetch = function (input, init) {
    var raw = typeof input === 'string' ? input : (input && input.url);
    var hit = raw ? isPredictive(raw) : null;
    if (!hit) return nativeFetch(input, init);
    if (!ready) { loadIndex(); return nativeFetch(input, init); }

    var original = hit.q;
    var res = search(original, 8);

    return nativeFetch(input, init).then(function (response) {
      if (!response.ok) return response;
      return response.text().then(function (html) {
        return repair(html, original, res, hit, response);
      });
    });
  };

  function respond(html, response) {
    return new Response(html, {
      status: response.status,
      statusText: response.statusText,
      headers: response.headers
    });
  }

  function decorate(doc, res, original, corrected) {
    var inner = doc.querySelector('.predictive-search-results__inner');
    if (!inner) return;

    regroup(doc);

    if (corrected) inner.insertBefore(noteEl(original, corrected), inner.firstChild);

    if (norm(original).length >= CFG.minChars && !doc.querySelector('[data-bb-pills]')) {
      var items = [];
      if (res.intent) items.push(res.intent);
      res.brands.concat(res.collections, res.guides).forEach(function (x) {
        if (items.length < CFG.maxPills && !items.some(function (i) { return i.title === x.title; })) items.push(x);
      });
      var ul = pillList(items.slice(0, CFG.maxPills));
      if (ul) inner.appendChild(ul);
    }
  }

  function serialize(doc) { return doc.body.innerHTML; }

  function repair(html, original, res, hit, response) {
    var doc = parse(html);
    var found = productCount(doc);

    // --- Layer 1: Shopify found products. Just add navigation pills. ---
    if (found > 0) {
      decorate(doc, res, original, null);
      return respond(serialize(doc), response);
    }

    track('bb_search_zero_results', { search_term: original });

    // --- Layer 2: repair the spelling and ask Shopify again. ---
    var step = Promise.resolve(null);
    if (res.correction && res.correction !== norm(original)) {
      var u2 = new URL(hit.url.toString());
      u2.searchParams.set('q', res.correction);
      step = nativeFetch(u2.toString(), { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (h2) {
          if (!h2) return null;
          var d2 = parse(h2);
          if (productCount(d2) === 0) return null;
          decorate(d2, res, original, res.correction);
          track('bb_search_recovered', { search_term: original, corrected_to: res.correction, method: 'spelling' });
          return serialize(d2);
        })
        .catch(function () { return null; });
    }

    // --- Layer 3: render our own matches through the theme's cards. ---
    return step.then(function (fixed) {
      if (fixed) return respond(fixed, response);
      if (!res.products.length) { decorate(doc, res, original, null); return respond(serialize(doc), response); }

      var ids = res.products.slice(0, 6).map(function (p) { return p.id; }).filter(Boolean);
      if (!ids.length) { decorate(doc, res, original, null); return respond(serialize(doc), response); }

      return fetchByIds(ids, hit.sid).then(function (h3) {
        if (!h3) { decorate(doc, res, original, null); return respond(serialize(doc), response); }
        var block = adaptRecoveredBlock(h3, 'Best matches');
        if (!block) { decorate(doc, res, original, null); return respond(serialize(doc), response); }

        var inner = doc.querySelector('.predictive-search-results__inner');
        if (!inner) return respond(serialize(doc), response);
        var noRes = inner.querySelector('.predictive-search-results__no-results');
        if (noRes) noRes.remove();
        inner.appendChild(doc.importNode(block, true));
        decorate(doc, res, original, null);
        track('bb_search_recovered', { search_term: original, method: 'local_index' });
        return respond(serialize(doc), response);
      });
    });
  }

  /* ======================================================================
     6. Search results page — repair the query on a full page load
     ====================================================================== */
  function fixSearchPage() {
    if (location.pathname.indexOf(routes().search) !== 0) return;
    var params = new URLSearchParams(location.search);
    var q = params.get('q');
    if (!q || params.get('bb_c')) return;              // never loop
    if (q.indexOf('id:') === 0) return;

    loadIndex().then(function (ok) {
      if (!ok) return;
      var res = search(q, 1);
      if (!res.correction || res.correction === norm(q)) return;

      var sug = function (term) {
        return nativeFetch(routes().predictive + '.json?q=' + encodeURIComponent(term) +
          '&resources[type]=product&resources[limit]=1', { credentials: 'same-origin' })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (j) {
            try { return j.resources.results.products.length; } catch (e) { return -1; }
          }).catch(function () { return -1; });
      };

      Promise.all([sug(q), sug(res.correction)]).then(function (counts) {
        if (counts[0] !== 0 || counts[1] <= 0) return;   // only act when broken -> fixed
        track('bb_search_recovered', { search_term: q, corrected_to: res.correction, method: 'results_page' });
        var url = new URL(location.href);
        url.searchParams.set('q', res.correction);
        url.searchParams.set('bb_c', q);
        location.replace(url.toString());
      });
    });
  }

  function showPageNote() {
    var params = new URLSearchParams(location.search);
    var from = params.get('bb_c');
    if (!from) return;
    var host = document.querySelector('.search-header, [class*="search-header"], main');
    if (!host) return;
    var p = noteEl(from, params.get('q') || '');
    p.style.margin = '0 0 var(--padding-md, 16px)';
    host.insertBefore(p, host.firstChild);
  }

  /* ======================================================================
     7. Header search dropdown
     ----------------------------------------------------------------------
     The BB v3 header (sections/…bb_header_v3nav) renders search as a plain
     <form class="bb-search"> that just submits to /search. The theme's own
     predictive-search component lives in a modal that this header never
     opens, so customers have never had a dropdown at all.

     Rather than build a new results UI, this fetches the theme's existing
     predictive-search section and anchors it under the header input. Every
     result card, pill and title is the theme's own markup and the theme's own
     CSS (73 of its 74 predictive-search rules are unscoped, so they apply
     outside the modal unchanged). The only new CSS is positioning.
     ====================================================================== */

  // The panel is fixed-positioned on <body>, not nested in the form: the BB v3
  // header sets overflow:hidden on form.bb-search (to clip the input's rounded
  // corners), which silently clips away anything absolutely positioned below it.
  // Fixed positioning also clears the sticky header's z-index:100 stacking.
  var PANEL_CSS = [
    '.bb-ss-panel{position:fixed;z-index:1000}',
    '.bb-ss-panel[hidden]{display:none !important}',
    '.bb-ss-panel > .predictive-search-dropdown{',
      'max-height:min(68vh,560px);overflow-y:auto;overflow-x:hidden;',
      'background:var(--color-background,#fff);border-radius:14px;',
      'border:1px solid rgba(17,19,17,.10);',
      'box-shadow:0 24px 60px -28px rgba(18,59,49,.45);}',
    '.bb-ss-panel .predictive-search-results__inner{width:100%;padding:8px}',

    // The theme's cards are laid out for the full-width search modal (a 2-up
    // grid of 245x373 tiles). In a dropdown they have to read as a compact
    // list. The card MARKUP stays the theme's — only the grid and media box
    // change, scoped to .bb-ss-panel so no other surface is affected.
    '.bb-ss-panel .predictive-search-results__wrapper-products{grid-template-columns:1fr !important;gap:2px !important}',
    '.bb-ss-panel .predictive-search-results__card--product{border:0}',
    '.bb-ss-panel .resource-card{display:grid;grid-template-columns:52px minmax(0,1fr);align-items:center;',
      'gap:12px;padding:8px 10px;border-radius:12px;height:68px;overflow:hidden}',
    '.bb-ss-panel .resource-card:hover{background:var(--color-accent,rgba(22,184,137,.08))}',
    '.bb-ss-panel .resource-card__media{width:52px;height:52px;min-height:0;aspect-ratio:1/1;',
      'border-radius:9px;overflow:hidden}',
    '.bb-ss-panel .resource-card__image{width:100%;height:100%;object-fit:contain}',
    '.bb-ss-panel .resource-card__image--secondary{display:none !important}',
    '.bb-ss-panel .resource-card__content{display:flex;flex-direction:column;justify-content:center;',
      'gap:2px;min-width:0;padding:0}',
    // never break a word mid-word — clip at two lines instead
    '.bb-ss-panel .resource-card__title{margin:0;font-size:14px;line-height:1.28;',
      'overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;',
      '-webkit-box-orient:vertical;overflow-wrap:normal;word-break:normal}',
    '.bb-ss-panel .price__regular,.bb-ss-panel .price__sale{font-size:13px}',
    '.bb-ss-panel .predictive-search-results__title{margin:10px 10px 4px;font-size:11px;',
      'letter-spacing:.1em;text-transform:uppercase;opacity:.62}',
    // the theme styles this class as a space-between flex row (a section header);
    // as a sentence it has to flow inline instead
    '.bb-ss-panel [data-bb-note]{display:block !important;white-space:normal;padding:0;',
      'margin:6px 10px 8px;font-size:13px;text-transform:none;letter-spacing:normal;opacity:1}',
    '.bb-ss-panel .predictive-search-results__wrapper-queries{display:flex !important;',
      'flex-wrap:wrap !important;overflow:visible !important;padding:0 8px 6px;gap:6px}',
    '.bb-ss-panel .predictive-search-results__wrapper-queries > *{flex:0 0 auto}',
    // the collection / article carousels are for the modal; a dropdown has no room
    '.bb-ss-panel slideshow-component{display:none !important}',

    '@media (max-width:749px){.bb-ss-panel > .predictive-search-dropdown{max-height:64vh}}'
  ].join('');

  function injectPanelCss() {
    if (document.getElementById('bb-ss-css')) return;
    var st = document.createElement('style');
    st.id = 'bb-ss-css';
    st.textContent = PANEL_CSS;
    document.head.appendChild(st);
  }

  function sectionId() {
    var psc = document.querySelector('predictive-search-component');
    return (psc && psc.dataset && psc.dataset.sectionId) || 'predictive-search';
  }

  function headerInputs() {
    return [].slice.call(document.querySelectorAll('input[name="q"]'))
      .filter(function (i) { return !i.closest('predictive-search-component'); });
  }

  function mountHeaderSearch(input) {
    if (input.__bbMounted) return;
    input.__bbMounted = true;
    injectPanelCss();

    var form = input.closest('form') || input.parentElement;
    var panel = document.createElement('div');
    // color-custom-popover is the theme's popover colour scheme. Without it the
    // dropdown inherits --color-foreground (#fcfcfa) and paints white-on-white,
    // because these result styles are written for the search modal's context.
    panel.className = 'bb-ss-panel color-custom-popover';
    panel.hidden = true;
    panel.setAttribute('role', 'listbox');
    document.body.appendChild(panel);

    function place() {
      var r = input.getBoundingClientRect();
      var margin = 12;
      var width = Math.max(r.width, 320);
      var left = Math.min(Math.max(margin, r.left), window.innerWidth - width - margin);
      if (window.innerWidth < width + margin * 2) { left = margin; width = window.innerWidth - margin * 2; }
      panel.style.left = Math.round(left) + 'px';
      panel.style.top = Math.round(r.bottom + 8) + 'px';
      panel.style.width = Math.round(width) + 'px';
    }
    window.addEventListener('scroll', function () { if (!panel.hidden) place(); }, { passive: true });
    window.addEventListener('resize', function () { if (!panel.hidden) place(); }, { passive: true });

    input.setAttribute('autocomplete', 'off');
    input.setAttribute('aria-expanded', 'false');

    var ctrl = null, timer = null, idx = -1, lastCorrection = null;

    function items() {
      return [].slice.call(panel.querySelectorAll(
        '.predictive-search-results__card--product, .predictive-search-results__card--query'
      ));
    }

    function close() {
      panel.hidden = true;
      panel.innerHTML = '';
      input.setAttribute('aria-expanded', 'false');
      idx = -1;
      lastCorrection = null;
    }

    function select(n) {
      var list = items();
      if (!list.length) return;
      list.forEach(function (el) { el.removeAttribute('aria-selected'); el.classList.remove('keyboard-focus'); });
      idx = (n + list.length) % list.length;
      list[idx].setAttribute('aria-selected', 'true');
      list[idx].classList.add('keyboard-focus');
      list[idx].scrollIntoView({ block: 'nearest' });
    }

    // paint straight from the local index — no network, sub-millisecond
    function renderLocal(q) {
      if (!ready) return false;
      var res = search(q, 8);
      var html = localDropdownHTML(res);
      if (!html) return false;
      var doc = parse(html);
      var dd = doc.querySelector('.predictive-search-dropdown');
      regroup(dd);
      tuneCardImages(dd);
      panel.innerHTML = '';
      panel.appendChild(document.importNode(dd, true));
      place();
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      idx = -1;
      return true;
    }

    // Shopify's markup is richer, but its recall is worse than the local index —
    // "fellow ode" renders 1 card server-side where the index knows about 6.
    // Keep Shopify's cards first, then top up with anything it missed, so the
    // list never shrinks under the customer as the response lands.
    function mergeLocalExtras(dd, q) {
      if (!ready) return;
      ungroup(dd);
      var list = dd.querySelector('.predictive-search-results__wrapper-products');
      if (!list) return;
      var have = {};
      [].slice.call(dd.querySelectorAll('.resource-card__link')).forEach(function (a) {
        var m = (a.getAttribute('href') || '').match(/\/products\/([^?#]+)/);
        if (m) have[m[1]] = 1;
      });
      var shown = dd.querySelectorAll('.predictive-search-results__card--product').length;
      var extras = search(q, 10).products.filter(function (p) { return p.handle && !have[p.handle]; });
      extras = extras.slice(0, Math.max(0, 8 - shown));
      if (!extras.length) return;
      var tmp = parse('<ul>' + localCardsHTML(extras) + '</ul>');
      [].slice.call(tmp.querySelectorAll('li')).forEach(function (li) { list.appendChild(li); });
    }

    function render(html, q) {
      var doc = parse(html);
      var dd = doc.querySelector('.predictive-search-dropdown');
      // keep the instant local results rather than blanking the panel
      if (!dd) { if (!panel.querySelector('[data-bb-local]')) close(); return; }
      mergeLocalExtras(dd, q);
      regroup(dd);
      tuneCardImages(dd);
      panel.innerHTML = '';
      panel.appendChild(document.importNode(dd, true));
      place();
      panel.hidden = false;
      input.setAttribute('aria-expanded', 'true');
      idx = -1;
      var note = panel.querySelector('[data-bb-note] strong');
      lastCorrection = note ? note.textContent.trim() : null;
    }

    function run(q) {
      if (ctrl) ctrl.abort();
      ctrl = new AbortController();
      var url = new URL(routes().predictive, location.origin);
      url.searchParams.set('q', q);
      url.searchParams.set('section_id', sectionId());
      url.searchParams.set('resources[limit_scope]', 'each');
      // deliberately window.fetch, not nativeFetch — the repair layers above
      // are what make a misspelled query return anything at all.
      window.fetch(url.toString(), { credentials: 'same-origin', signal: ctrl.signal })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) { if (html) render(html, q); })
        .catch(function () { /* aborted or offline: leave the panel as it was */ });
    }

    input.addEventListener('input', function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < CFG.minChars) { close(); return; }
      loadIndex();
      renderLocal(q);                       // instant, every keystroke
      timer = setTimeout(function () { run(q); }, 180);   // authoritative, debounced
    });

    input.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); return; }
      if (panel.hidden) return;
      if (e.key === 'ArrowDown') { e.preventDefault(); select(idx + 1); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); select(idx - 1); }
      else if (e.key === 'Enter') {
        var cur = items()[idx];
        var link = cur && cur.querySelector('a');
        if (link) { e.preventDefault(); window.location.href = link.href; }
      }
    });

    // Typing then pressing Enter should land on the repaired query directly,
    // rather than loading an empty results page and redirecting off it.
    if (form && form.tagName === 'FORM') {
      form.addEventListener('submit', function () {
        if (lastCorrection && lastCorrection !== input.value.trim()) {
          var original = input.value.trim();
          input.value = lastCorrection;
          var hidden = document.createElement('input');
          hidden.type = 'hidden';
          hidden.name = 'bb_c';
          hidden.value = original;
          form.appendChild(hidden);
          track('bb_search_recovered', { search_term: original, corrected_to: lastCorrection, method: 'submit' });
        }
      });
    }

    input.addEventListener('focus', function () {
      loadIndex();
      var q = input.value.trim();
      if (q.length >= CFG.minChars && panel.hidden) { renderLocal(q); run(q); }
    });

    document.addEventListener('click', function (e) {
      if (panel.hidden) return;
      if (form.contains(e.target) || panel.contains(e.target)) return;
      close();
    });
  }

  function mountAll() {
    headerInputs().forEach(mountHeaderSearch);
  }

  /* ====================================================================== */
  armLazyLoad();
  function boot() { mountAll(); fixSearchPage(); showPageNote(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  // the header can be re-rendered by section morphs; re-attach when it is
  if (window.MutationObserver) {
    new MutationObserver(function () { mountAll(); })
      .observe(document.documentElement, { childList: true, subtree: true });
  }

  window.BBSearch = { search: search, loadIndex: loadIndex, isReady: function () { return ready; }, mount: mountAll };
})();
